import clsx from "clsx";
import { SectionTitle, Subtitle, TextBadge } from "components/atoms/Text";
import { featureList } from "data";
import ProductFeatureCard from "components/organism/Cards/ProductFeatureCard";

const LinkedinFeatures = () => {
    return (
        <section className="features w-full phone:py-12 tablet:py-16 desktop:py-[88px] pb-20 bg-neutral-20">
            <div className="max-w-[1440px] mx-auto">
                <section className={clsx(
                    "w-full mx-auto max-w-full tablet:max-w-[632px] desktop:max-w-[628px] text-center",
                    "px-6 md:px-0"
                )}>
                    <TextBadge>Features</TextBadge>
                    <SectionTitle classNames="tablet:!text-[40px] tablet:!leading-[54px]">Our Features</SectionTitle>
                    <Subtitle classNames="phone:tracking-normal !leading-[27.2px]">Our infrastructure is unique, battle-tested and carefully monitored by supervisors 24/7. There is no other proxy provider even close to operating at the same level and standards that we do.</Subtitle>
                </section>
                <section className={clsx(
                    "grid grid-cols-1 md:grid-cols-3 phone:gap-6 tablet:gap-6 gap-8",
                    "pt-16 pb-0 phone:pt-12 phone:pb-0 tablet:pt-14 tablet:pb-0 px-6 tablet:px-8 desktop:px-[120px]"
                )}>
                    {featureList.slice(0, 6).map((item) => (
                        <ProductFeatureCard key={item.id} icons={item.icons} title={item.title} description={item.description} classNames="bg-neutral-10 tablet:!p-6 phone:!py-6" />
                    ))}
                </section>
            </div>
        </section>
    );
};

export default LinkedinFeatures;